import { FC } from "react";
import { Text } from "@otrium/atoms";

interface FacetTextProps {
  itemsLength: number | undefined;
  index: number;
  facet: {
    label: string;
  };
}

const FacetText: FC<FacetTextProps> = ({ facet, itemsLength, index }) => {
  const lastItem = itemsLength ? itemsLength - 1 === index : false;
  const splitLabel = facet.label.split("||");
  const label = lastItem ? `${splitLabel[1]}` : `${splitLabel[1]},`;
  return (
    <Text mr={"2px"} as="span" key={label}>
      {label}
    </Text>
  );
};

export default FacetText;
